/**
 * Project panel
 *
 * Created by stefensuhat on 11/08/18 10.48 AM
 */

import { api } from 'utils/index';

const defaultState = {
    items: [],
    data: [],
    meta: {
        total: 0, to: 0, per_page: 0, current_page: 0, last_page: 1,
    },
    statistic: {},
    errors: null,
    saved: false,
};

export default {
    name: 'subscription',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({
            ...state,
            items: payload.data,
            data: [...state.data, ...payload.data],
            meta: payload.meta,
        }),
        storeResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }

            return { ...state, saved: true };
        },
        statisticResponse: (state, payload) => ({ ...state, statistic: payload }),
    },
    effects: {
        async fetch(params) {
            await api.get('transactions', { params })
                .then((response) => this.fetchResponse(response));
        },

        async store(values) {
            await api.post('subscriptions', values)
                .then((response) => this.storeResponse(response));
        },
        async fetchStatistic() {
            await api.get('subscriptions/statistic')
                .then((response) => this.statisticResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.subscription, (subscription) => subscription.items);
        },
        find() {
            return createSelector(
                (slice) => slice.subscription.data,
                (state, selectedId) => selectedId,
                (subscriptions, selectedId) => subscriptions.find((subscription) => subscription.id === selectedId),
            );
        },
        statistic() {
            return createSelector(slice, (state) => state.subscription, (subscription) => subscription.statistic);
        },
    }),
};
